import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    Switch,
    FormHelperText
} from '@material-ui/core';
import { AccordionSetup } from '@commonClient2/components';
import { UPDATE_GLOBAL_SETUP } from '../../store/globalSetup';
import ToggleNumericSetting from '../ToggleNumericSetting';
import './EmployeesArchiveSettings.scss';

/**
 * @param {{
 *  isLoading: boolean;
 *  step: number;
 *  globalSetups: GlobalSetup.GlobalSetup;
 * }}
 * param0  */
const EmployeesArchiveSettings = ({ 
    isLoading, step, globalSetups 
}) => {
    const isEmployeesArchiveHiddenName = 'isEmployeesArchiveHidden';
    const isEnabledEmployeesAutoArchiveSignedOffBidsDelayName = 'isEmployeesAutoArchiveOnSignedOffBidEnabled';
    const employeesAutoArchiveSignedOffBidsDelayName = 'employeesSignedOffBidAutoArchiveNumberOfDays';
    const isEnabledEmployeesAutoArchiveCancelledBidsDelayName = 'isEmployeesAutoArchiveOnCancelledBidEnabled';
    const employeesAutoArchiveCancelledBidsDelayName = 'employeesCancelledBidAutoArchiveNumberOfDays';

    const { t } = useTranslation('globalSetup', { keyPrefix: 'employeesArchive' });
    const { t: tCommon } = useTranslation('common');
    const dispatch = useDispatch();
    const { employeesArchiveSettings: rules } = globalSetups;
    const {
        isEmployeesArchiveHidden,
        isEmployeesAutoArchiveOnCancelledBidEnabled,
        employeesCancelledBidAutoArchiveNumberOfDays,
        isEmployeesAutoArchiveOnSignedOffBidEnabled,
        employeesSignedOffBidAutoArchiveNumberOfDays
    } = rules;
    
    /**
     * @template T
     * @param {T} value
     */
    const updateStore = (value) => {
        dispatch({
            type: UPDATE_GLOBAL_SETUP,
            payload: { employeesArchiveSettings: value },
        });
    };

    /**
     * @param {string} field
     * @param {*} value
     */
    const onChange = (field, value) => {
        updateStore({ ...rules, [field]: value });
    };

    /**
     * @param {string} toggleField
     * @param {string} inputField
     * @param {number} value
     * @param {boolean} checked
     */
    const onToggleChange = (toggleField, inputField, value, checked) => {
        if (!checked) {
            value = 0;
        }
        updateStore({ ...rules, [toggleField]: checked, [inputField]: value });
    };

    return (
        <AccordionSetup
            stepIndex={step.toString()}
            headerTitle={t('title')}
            summary=""
            className="employees-archive-step"
        >
            <div>
                <span className="isEmployeesArchiveHidden-switch-setting">
                    <Switch
                        name={t('isEmployeesArchiveHiddenName')}
                        checked={isEmployeesArchiveHidden}
                        onChange={(e) => {
                            onChange(isEmployeesArchiveHiddenName, e.target.checked);
                        }}
                        color="primary"
                        disabled={isLoading}
                        className="isEmployeesArchiveHidden-switch"
                    />
                    {t('isEmployeesArchiveHidden')}
                </span>

                <ToggleNumericSetting
                    toggleName={isEnabledEmployeesAutoArchiveSignedOffBidsDelayName}
                    inputName={employeesAutoArchiveSignedOffBidsDelayName}
                    toggleValue={isEmployeesAutoArchiveOnSignedOffBidEnabled}
                    inputValue={employeesSignedOffBidAutoArchiveNumberOfDays}
                    isDisabled={isLoading}
                    label={t('setAutoArchiveOnSignedOffBids')}
                    unitLabel={tCommon('days')}
                    isInputDisabled={!isEmployeesAutoArchiveOnSignedOffBidEnabled}
                    onToggleChange={(e) => {
                        onToggleChange(
                            isEnabledEmployeesAutoArchiveSignedOffBidsDelayName,
                            employeesAutoArchiveSignedOffBidsDelayName,
                            employeesSignedOffBidAutoArchiveNumberOfDays,
                            e.target.checked
                        );
                    }}
                    onNumberChange={(e) => {
                        onChange(employeesAutoArchiveSignedOffBidsDelayName, Number(e.target.value));
                    }}
                    showWarning={false}
                    isSetupWithRebidsAllowedExist={false}
                />
                <ToggleNumericSetting
                    toggleName={isEnabledEmployeesAutoArchiveCancelledBidsDelayName}
                    inputName={employeesAutoArchiveCancelledBidsDelayName}
                    toggleValue={isEmployeesAutoArchiveOnCancelledBidEnabled}
                    inputValue={employeesCancelledBidAutoArchiveNumberOfDays}
                    isDisabled={isLoading}
                    label={t('setAutoArchiveOnCancelledBids')}
                    unitLabel={tCommon('days')}
                    isInputDisabled={!isEmployeesAutoArchiveOnCancelledBidEnabled}
                    onToggleChange={(e) => {
                        onToggleChange(
                            isEnabledEmployeesAutoArchiveCancelledBidsDelayName,
                            employeesAutoArchiveCancelledBidsDelayName,
                            employeesCancelledBidAutoArchiveNumberOfDays,
                            e.target.checked
                        );
                    }}
                    onNumberChange={(e) => {
                        onChange(employeesAutoArchiveCancelledBidsDelayName, Number(e.target.value));
                    }}
                    showWarning={false}
                    isSetupWithRebidsAllowedExist={false}
                />
                <FormHelperText className="info">{t('autoArchiveBidsInfo')}</FormHelperText>
            </div>
        </AccordionSetup>
    );
};

export default EmployeesArchiveSettings;
